import logo from './logo.png'

export const Logo = () => {
    return (
        <div>
            <img src= {logo} alt="logo" height="115" />
        </div>
    )
}